import{jsx as r}from"react/jsx-runtime";import s from"../assets/error.module.scss";const o=({apiError:e})=>e.message?r("div",{className:s.error__message,children:e.message}):null;export{o as ApiErrorComponentMessage};
